// extracted by mini-css-extract-plugin
module.exports = {"ABOUT":"DiscountBanner_ABOUT__1Ymf-","ABOUT__left_col":"DiscountBanner_ABOUT__left_col__3XCKS","ABOUT__right_col":"DiscountBanner_ABOUT__right_col__3lqQh"};